<script setup>
import { ref, onMounted, defineComponent } from 'vue'

defineComponent({
  name: 'GestionCookies'
})

const isOptedOut = ref(false)
const statusLoaded = ref(false)
const matomoBloque = ref(false)

onMounted(async () => {
  const disponible = await attendreMatomo()
  if (!disponible) {
    matomoBloque.value = true
    statusLoaded.value = true
    return
  }
  const tracker = window.Matomo.getAsyncTracker()
  isOptedOut.value = tracker.isUserOptedOut()
  statusLoaded.value = true
})

function attendreMatomo() {
  return new Promise((resolve) => {
    if (window.Matomo) {
      resolve(true)
      return
    }
    let elapsed = 0
    const interval = setInterval(() => {
      if (window.Matomo) {
        clearInterval(interval)
        resolve(true)
      } else if (elapsed >= 5000) {
        clearInterval(interval)
        resolve(false)
      }
      elapsed += 100
    }, 100)
  })
}

function retirerConsentement() {
  window._paq.push(['optUserOut'])
  isOptedOut.value = true
}

function donnerConsentement() {
  window._paq.push(['forgetUserOptOut'])
  isOptedOut.value = false
}
</script>

<template>
  <div class="home container overflow-auto">
    <h1>Cookies</h1>

    <div class="card">
      <div class="card-body">
        <h2>Cookies exemptés de consentement préalable</h2>
        <p>
          <strong>Matomo</strong> : Ces cookies nous permettent de réaliser des mesures d'audience
          et de performance sur le site internet. Le produit est paramétré conformément aux
          recommandations de la CNIL sur l'exemption de consentement.
        </p>

        <div v-if="!statusLoaded" class="text-center my-3">
          Chargement…
        </div>

        <p v-else-if="matomoBloque">
          Les mesures d'audience sont déjà inactives (script Matomo bloqué par votre navigateur).
        </p>

        <p v-else>
          Vous pouvez {{ isOptedOut ? 'réactiver' : 'désactiver' }} les mesures d'audience en cliquant sur ce bouton :
          <button v-if="!isOptedOut" class="btn btn-rouge btn-sm" @click="retirerConsentement">
            Désactiver
          </button>
          <button v-else class="btn btn-activer" @click="donnerConsentement">
            Activer
          </button>
        </p>
      </div>
    </div>
  </div>
  <br>
</template>

<style scoped lang="scss">
@import "@/assets/main";

.card {
  border: none !important;
}

.btn-rouge,
.btn-activer {
  padding: 0.25rem 0.75rem;
  font-size: 0.875rem;
  border-radius: 0.375rem;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  cursor: pointer;
  border: none;
  color: white;
  width: auto;
  height: auto;
}

.btn-rouge {
  background-color: #dc3545;

  &:hover {
    background-color: #c82333;
  }
}

.btn-activer {
  background-color: var(--color-vert-logo);

  &:hover {
    background-color: white;
    color: var(--color-vert-logo);
    border: 1px solid var(--color-vert-logo);
  }
}
</style>
